import { TooltipProps } from "recharts";
import { NameType, ValueType } from "recharts/types/component/DefaultTooltipContent";


export const CustomTooltip = ({
    active,
    payload,
}: TooltipProps<ValueType, NameType>) => {
    if (active && payload && payload.length > 0) {
        const { name, value, percent } = payload[0].payload;

        return (
            <div className="bg-white dark:bg-secondary-800 text-sm shadow-lg rounded p-3 border border-gray-200 dark:border-secondary-600">
                <p className="font-semibold">{name}</p>
                <p>Valor: <span className="font-medium">{value.toLocaleString()}</span></p>
                <p>Porcentaje: <span className="font-medium">{(percent * 100).toFixed(2)}%</span></p>
            </div>
        );
    }

    return null;
};